// import { ArrayData as AdminAccountantRoutes } from "./routes/AdminAccountantRoutes";
// import { ArrayData as ClientListRoutes } from "./routes/ClientListRoutes";
// import { ArrayData as ClientListRoutesWithAcc } from "./routes/ClientListRoutesWithAcc";
// import { ArrayData as AccountantListRoutes } from "./routes/AccountantListRoutes";
// import { ArrayData as ClientRoutes } from "./routes/ClientRoutes";
// import { ArrayData as AdminClientRoutes } from "./routes/AdminClientRoutes";
// import { ArrayData as AdminRoutes } from "./routes/AdminRoutes";

import "./RoleBasedTopMenuBar.css"

import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";

import { AccountantListRoutesComponent } from "./routes/AccountantListRoutes";
import { AccountantService } from "../../services";
import { AdminAccountantRoutesComponent } from "./routes/AdminAccountantRoutes";
import { AdminClientRoutesComponent } from "./routes/AdminClientRoutes";
import { AdminRoutesComponent } from "./routes/AdminRoutes";
import { ClientListRoutesComponent } from "./routes/ClientListRoutes";
import { ClientListRoutesWithAccComponent } from "./routes/ClientListRoutesWithAcc";
import { ClientRoutesComponent } from "./routes/ClientRoutes";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { Menubar } from "primereact/menubar";
import { setSelectedHomePage } from "../../store/actions";
import { useQuery } from "@tanstack/react-query";

const useAccountants = (params: IGetListRequest, isAdminUser: number, selectedAccountantId: string) =>
  useQuery({
    queryKey: ["accountants-list", params, isAdminUser, selectedAccountantId],
    queryFn: (data) => {
      return AccountantService.getAccountantsToManageNavBar(params, isAdminUser, selectedAccountantId);
    },
    refetchOnWindowFocus: false
  }
  );











export const RoleBasedTopMenuBar = () => {
  const dispatch = useDispatch();
  const { AdminAccountantRoutes } = AdminAccountantRoutesComponent()
  const { ClientListRoutes } = ClientListRoutesComponent()
  const { ClientListRoutesWithAcc } = ClientListRoutesWithAccComponent()
  const { AccountantListRoutes } = AccountantListRoutesComponent()
  const { ClientRoutes } = ClientRoutesComponent()
  const { AdminClientRoutes } = AdminClientRoutesComponent()
  const { AdminRoutes } = AdminRoutesComponent()

  // let { isAdminUser, selectedAccountantId, selectedAccountantName, selectedClientId, selectedClientName, selectedYear, invoiceRefNo, CSVInformationUI, HomePagePath, selectedMenuItem, drawerAction } = useSelector(
  //   (state: IAppState) => {
  //     return {
  //       isAdminUser: state.user.profile.isSuperStatus,
  //       selectedAccountantId: state.accountant.id,
  //       selectedAccountantName: state.accountant.AccountantName,
  //       selectedClientId: state.client.id,
  //       selectedClientName: state.client.clientName,
  //       selectedYear: state.taxYear.year,
  //       invoiceRefNo: state.invoice.refNo,
  //       CSVInformationUI: state.CSVInformationUI,
  //       HomePagePath: state.HomePagePath.path,
  //       selectedMenuItem: state.navigation.selectedMenuItem,
  //       drawerAction: state.drawerAction.open
  //     };
  //   }
  // );
  const isAdminUser = useSelector(
    (state: IAppState) => state.user.profile.isSuperStatus
  );

  const selectedAccountantId = useSelector(
    (state: IAppState) => state.accountant.id
  );

  const selectedAccountantName = useSelector(
    (state: IAppState) => state.accountant.AccountantName
  );

  const selectedClientId = useSelector(
    (state: IAppState) => state.client.id
  );

  const selectedClientName = useSelector(
    (state: IAppState) => state.client.clientName
  );

  const selectedYear = useSelector(
    (state: IAppState) => state.taxYear.year
  );

  const invoiceRefNo = useSelector(
    (state: IAppState) => state.invoice.refNo
  );

  const CSVInformationUI = useSelector(
    (state: IAppState) => state.CSVInformationUI
  );

  const HomePagePath = useSelector(
    (state: IAppState) => state.HomePagePath.path
  );

  const selectedMenuItem = useSelector(
    (state: IAppState) => state.navigation.selectedMenuItem
  );

  const drawerAction = useSelector(
    (state: IAppState) => state.drawerAction.open
  );

  const activityLog = useSelector(
    (state: IAppState) => state.activityLog
  );

  const isLoadAxiosCall = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );

  const stickyNavBar = useSelector(
    (state: IAppState) => state.stickyNavBar.isSticky
  );

  const dashboard = useSelector(
    (state: IAppState) => state.dashboardApisData
  );

  const queryParams = useMemo(
    () => ({
      search_query: "",
      order_by: "accTitle",
      order_direction: "asc",
      page: 1,
      size: 25
    }),
    []
  );
  const { isLoading, data } = useAccountants(queryParams, isAdminUser, selectedAccountantId);
  const accountantList: any = data;
  const [menu, setMenu] = useState<any>(AdminRoutes);
  useEffect(() => {
    if (isAdminUser !== 0) {
      if (selectedClientId && selectedClientId.length > 0) {
        dispatch(setSelectedHomePage({ path: "/clients/dashboard" }));

        setMenu(AdminClientRoutes);
      }
      else if (selectedAccountantId && selectedAccountantId.length > 0) {
        dispatch(setSelectedHomePage({ path: "/accountants/clients" }));

        setMenu(AdminAccountantRoutes);
      }
      else {
        dispatch(setSelectedHomePage({ path: "/global-search" }));

        setMenu(AdminRoutes);
      }
    }
    else {
      if (selectedClientId && selectedClientId.length > 0) {
        dispatch(setSelectedHomePage({ path: "/clients/dashboard" }));
        setMenu(ClientRoutes)
      }
      else if (selectedAccountantId && selectedAccountantId.length > 0) {
        dispatch(setSelectedHomePage({ path: "/accountants/clients" }));

        if (accountantList && accountantList.items && accountantList.items.length !== 0) {

          setMenu(ClientListRoutesWithAcc);
        } else {
          setMenu(ClientListRoutes);
        }
      }
      else {
        dispatch(setSelectedHomePage({ path: "/accountants" }));
        setMenu(AccountantListRoutes);
      }
    }
  }, [accountantList, selectedClientId, selectedAccountantId]);

  return <Menubar model={menu} className='menu-bar' />;
};
